module.exports = __webpack_public_path__ + "img/linkedin.291eb7f6.svg";